import React, { useEffect, useState } from "react";
import { useAuthState } from "../provider/AuthProvider";
import { Select } from "antd";

import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

function SelectRentCar({
    value,
    showTitle,
    onChange,
    onChangeInfo,
}: {
    value?: string;
    showTitle?: boolean;
    onChange?: (value: string) => void;
    onChangeInfo?: (value: Types.RentCarDto) => void;
}) {
    const { Option } = Select;
    const [rentCars, setRentCars] = useState<Array<Types.RentCarDto>>([]);

    useEffect(() => {
        requestGetRentCars();
    }, []);

    const requestAxiosGetRentCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_CARS_ALL_URL);
        return response.data;
    };

    const {
        loading: loadingGetRentCars,
        error: errorGetRentCars,
        data: resultGetRentCars,
        execute: requestGetRentCars,
    } = useAsyncAxios(requestAxiosGetRentCars);

    useEffect(() => {
        if (resultGetRentCars === null) return;
        console.log("resultGetRentCars", resultGetRentCars);

        setRentCars(resultGetRentCars.rentCars);
    }, [resultGetRentCars]);

    useEffect(() => {
        if (errorGetRentCars === null) return;

        console.log("errorGetRentCars", errorGetRentCars);
    }, [errorGetRentCars]);

    useEffect(() => {
        console.log("rentCars", rentCars);
    }, [rentCars]);

    const onChangeRentCar = (value: string) => {
        onChange !== undefined && onChange(value);

        const data = rentCars.filter((car) => car.car.carNumber === value)[0];
        onChangeInfo !== undefined && onChangeInfo(data);
    };

    return (
        <Select value={value} onChange={onChangeRentCar} placeholder="차량 선택" showSearch allowClear>
            {rentCars.length > 0
                ? rentCars.map((option) => {
                      return (
                          <Option key={option.rentCarId} value={option.car.carNumber}>
                              {showTitle ? option.car.carNumber + " / " + option.title : option.car.carNumber}
                          </Option>
                      );
                  })
                : null}
        </Select>
    );
}

export default SelectRentCar;
